import { defineComponent } from "vue";

export default defineComponent({
  props: {
    stepNumber: {
      type: String,
    },
    stepTitle: {
      type: String,
    },
    nextButtonActive: {
      type: Boolean,
      default: false,
    },
    btnNextLabel: {
      type: String,
      default: "Continuar",
    },
    onlyCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nextDismissAnimation: false,
      nextShowAnimation: false,
      previousDismissAnimation: false,
      previousShowAnimation: false,
    };
  },
  methods: {
    setNextShowAnimation() {
      setTimeout(() => {
        this.nextShowAnimation = true;
        document.body.style.overflow = "hidden";
        setTimeout(() => {
          this.nextShowAnimation = false;
          document.body.style.overflow = "visible";
        }, 300);
      }, 100);
    },
    setNextDismissAnimation() {
      this.nextDismissAnimation = true;
      document.body.style.overflow = "hidden";
      setTimeout(() => {
        this.nextDismissAnimation = false;
        document.body.style.overflow = "visible";
      }, 300);
    },
    setPreviousShowAnimation() {
      setTimeout(() => {
        this.previousShowAnimation = true;
        document.body.style.overflow = "hidden";
        setTimeout(() => {
          this.previousShowAnimation = false;
          document.body.style.overflow = "visible";
        }, 300);
      }, 100);
    },
    setPreviousDismissAnimation() {
      this.previousDismissAnimation = true;
      document.body.style.overflow = "hidden";
      setTimeout(() => {
        this.previousDismissAnimation = false;
        document.body.style.overflow = "visible";
      }, 300);
    }
  }
});
